import { jsxs as d, jsx as o } from "react/jsx-runtime";
import { forwardRef as x } from "react";
import { c as w } from "./cn-DlLpp5ix.js";
function b(s, t, a) {
  return Math.max(t, Math.min(a, s));
}
const k = {
  accent: "var(--accent-default)"
}, M = x(function({
  value: t,
  max: a = 100,
  size: r = 30,
  strokeWidth: e = 3,
  tone: i = "accent",
  centerSlot: l,
  className: m,
  style: p,
  "aria-label": u,
  ...h
}, g) {
  const c = b(t, 0, a), n = (r - e) / 2, f = 2 * Math.PI * n, y = f * (1 - c / a), v = {
    position: "relative",
    display: "inline-flex",
    width: r,
    height: r,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    ...p
  };
  return /* @__PURE__ */ d(
    "span",
    {
      ref: g,
      "data-ls-component": "progress-ring",
      "data-tone": i,
      role: "progressbar",
      "aria-label": u,
      "aria-valuenow": c,
      "aria-valuemin": 0,
      "aria-valuemax": a,
      className: w(m),
      style: v,
      ...h,
      children: [
        /* @__PURE__ */ d("svg", { width: r, height: r, viewBox: `0 0 ${r} ${r}`, "aria-hidden": "true", children: [
          /* @__PURE__ */ o(
            "circle",
            {
              cx: r / 2,
              cy: r / 2,
              r: n,
              fill: "none",
              stroke: "var(--bg-elevated)",
              strokeWidth: e
            }
          ),
          /* @__PURE__ */ o(
            "circle",
            {
              cx: r / 2,
              cy: r / 2,
              r: n,
              fill: "none",
              stroke: k[i],
              strokeWidth: e,
              strokeLinecap: "round",
              strokeDasharray: f,
              strokeDashoffset: y,
              transform: `rotate(-90 ${r / 2} ${r / 2})`,
              style: { transition: "stroke-dashoffset var(--duration-slower) var(--ease-out)" }
            }
          )
        ] }),
        l ? /* @__PURE__ */ o(
          "span",
          {
            "aria-hidden": "true",
            style: {
              position: "absolute",
              inset: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "var(--font-sans)",
              fontSize: Math.max(9, Math.round(r / 3)),
              fontWeight: 700,
              color: "var(--text-primary)"
            },
            children: l
          }
        ) : null
      ]
    }
  );
});
M.displayName = "ProgressRing";
export {
  M as P
};
//# sourceMappingURL=ProgressRing-C9g1ohUx.js.map
